import { ajax } from '../../util'

export function submitFavoritesSuccess(data: boolean) {
    return {
        type: 'SUBMIT_FAVORITES_SUCCESS',
        data
    }
}

export function isSubmittingFavorites(data: boolean) {
    return {
        type: 'SUBMITTING_FAVORITES',
        data
    }
}

export function submitFavoritesError(data: string) {
    return {
        type: 'SUBMIT_FAVORITES_ERROR',
        data
    }
}

export function submitFavorites(data: object) {
    return (dispatch: any) => {
        dispatch(isSubmittingFavorites(true))
        const url = '/api/favorites/'

        ajax(url, data, 'POST').then(res => {
            if (res.hasError) {
                dispatch(submitFavoritesError(res[Object.keys(res)[0]]))
            } else {
                dispatch(submitFavoritesSuccess(true))
            }
            dispatch(isSubmittingFavorites(false))
        })
    }
}

export function fetchedReports(data: object) {
    return {
        type: 'FETCH_REPORTS_SUCCESS',
        data
    }
}

export function fetchingReports(data: boolean) {
    return {
        type: 'FETCHING_REPORTS',
        data
    }
}

export function fetchReportsError(data: string) {
    return {
        type: 'FETCH_REPORTS_ERROR',
        data
    }
}

export function fetchReports(subscribes: any, page: number) {
    return (dispatch: any) => {
        dispatch(fetchingReports(true))
        const url = '/api/research_report/rr_initialization/subscribes=' + subscribes + '/' + (page ? page : 1)
        ajax(url, {}, 'GET').then(res => {
            if (res.hasError) {
                dispatch(fetchReportsError(res[Object.keys(res)[0]]))
            } else {
                dispatch(fetchedReports(res))
            }
            dispatch(fetchingReports(false))
        })
    }
}

export function fetchedSubscribes(data: any) {
    return {
        type: 'FETCH_SUBSCRIBES_SUCCESS',
        data
    }
}

export function fetchingSubscribes(data: boolean) {
    return {
        type: 'FETCHING_SUBSCRIBES',
        data
    }
}

export function fetchSubscribesError(data: string) {
    return {
        type: 'FETCH_SUBSCRIBES_ERROR',
        data
    }
}

export function fetchSubscribes(data: object) {
    return (dispatch: any) => {
        dispatch(fetchingSubscribes(true))
        const url = '/api/user/get_subscribe'

        ajax(url, data, 'GET').then(res => {
            if (res.hasError) {
                dispatch(fetchSubscribesError(res[Object.keys(res)[0]]))
            } else {
                dispatch(fetchedSubscribes(res))
            }
            dispatch(fetchingSubscribes(false))
        })
    }
}

export function submitSubscribesSuccess(data: object) {
    return {
        type: 'SUBMIT_SUBSCRIBES_SUCCESS',
        data
    }
}

export function submittingSubscribes(data: boolean) {
    return {
        type: 'SUBMITTING_SUBSCRIBES',
        data
    }
}

export function submitSubscribesError(data: string) {
    return {
        type: 'SUBMIT_SUBSCRIBES_ERROR',
        data
    }
}

export function submitSubscribes(data: object) {
    return (dispatch: any) => {
        dispatch(submittingSubscribes(true))
        const url = 'api/user/update_subscribe'

        ajax(url, data, 'POST').then(res => {
            if (res.hasError) {
                dispatch(submitSubscribesError(res[Object.keys(res)[0]]))
            } else {
                dispatch(submitSubscribesSuccess(res))
            }
            dispatch(fetchingSubscribes(false))
        })
    }
}

export function fetchNewReport(data: object) {
    return {
        type: 'NEW_REPORT',
        data
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/scenes/Article/actions.tsx